/* Lunalume · Lichtschalter
 *
 * Ein Schalter IM BILD, oben rechts - auf der Produktseite ueber der
 * Galerie, auf Uebersichtsseiten in jeder Produktkachel. Egal welchen man
 * drueckt: er schaltet die GANZE Seite um. Die Wahl haelt ueber
 * Seitenwechsel.
 *
 * WARUM DAS OHNE ZUORDNUNGSTABELLE GEHT: die Studiobilder folgen einem
 * strengen Namensschema, render_<Modell>_<Ansicht>.png, und zu jeder
 * unbeleuchteten Ansicht existiert genau eine beleuchtete. Kommt ein neues
 * Modell dazu, wirkt es ohne Codeaenderung mit.
 *
 * ZWEI FAELLE, sauber getrennt:
 *   A) Karten, Startseite, Suche, Empfehlungen - EIN Bild je Produkt.
 *      Es wird gegen sein Gegenstueck getauscht (src, srcset, <source>).
 *   B) Die Produktgalerie traegt BEIDE Zustaende als zehn Medien. Dort
 *      wird nicht getauscht (das gaebe Dubletten), sondern die Folien des
 *      anderen Zustands werden ausgeblendet - samt Vorschaubildern.
 *
 * DIE FALLE BEI B, zweimal hineingelaufen: die Galerie ist ein
 * Scroll-Karussell. Blendet man Folien aus, ohne die Auswahl mitzufuehren,
 * bleibt die als "is-selected" markierte Folie versteckt, das Karussell
 * steht auf einer leeren Stelle und das Hauptbild ist weg. Deshalb wird
 * nach jedem Ausblenden geprueft, ob die aktive Folie noch sichtbar ist,
 * und andernfalls die erste sichtbare ueber ihr Vorschaubild angewaehlt.
 *
 * DIE FALLE MIT DEM PUNKT, gefunden 28.08.2026. Shopify haengt beim
 * Hochladen eine UUID an, sobald zum Upload-Zeitpunkt schon ein Bild mit
 * demselben Namen existiert (etwa waehrend eines Austauschs, wo die
 * alten Bilder erst nach der Pruefung geloescht werden):
 * render_Crema_kopf_hell.png wird zu
 * render_Crema_kopf_hell_ddbd3c3c-6e11-4818-af16-635df18b6320.png. Die
 * Muster unten endeten auf einen woertlichen Punkt ('_kopf_hell.') und
 * fanden danach nichts mehr - weder zustand() noch gegenstueck() griffen,
 * knoepfeSetzen() haengte an keiner Galeriefolie mehr einen Schalter an,
 * und die Seite fiel auf den EINEN schwebenden Rueckfallschalter zurueck,
 * der sonst nur fuer Textseiten ohne Produktbild gedacht ist.
 * treffer() erkennt seither beide Enden: einen Punkt (sauberer Name)
 * oder einen Unterstrich (Name plus angehaengte UUID).
 *
 * Damit war die GALERIE (Fall B) repariert - sie braucht nur Erkennung.
 * Fall A braucht mehr: gegenstueck() KONSTRUIERT eine Adresse durch
 * Text-Ersetzung, und "hell" und "dunkel" bekommen beim Hochladen
 * UNABHAENGIGE, zufaellige UUIDs. Eine Konstruktion wuerde dann eine
 * Adresse erfinden, die es nicht gibt - deshalb gibt gegenstueck() bei
 * einer UUID bewusst auf (null statt eines toten Links).
 *
 * DER DIMMER, 31.08.2026: beim Umschalten wird nicht mehr hart
 * getauscht, sondern ueberblendet - siehe den Abschnitt "Der Dimmer"
 * weiter unten. Nur beim aktiven Umschalten; der Seitenaufbau bleibt
 * hart, dafuer sorgt das Kopf-Skript.
 *
 * DAS GESTAPELTE PAAR, 31.08.2026 (zweiter Anlauf). Der Dimmer blendete
 * EIN Bild aus, tauschte src/srcset und blendete es wieder ein. Er kann
 * beide Zustaende nie zugleich zeigen und wirkt deshalb haerter als
 * noetig. Vorbild incommonwith.com, dort am Live-DOM ausgemessen: beide
 * Zustaende liegen GLEICHZEITIG im Baum, das Gegenstueck absolut ueber
 * dem Original, und der Schalter kippt nur die Deckkraft - gegenlaeufig,
 * so dass man waehrend der Blende beide zugleich sieht. Nichts wird
 * nachgeladen, nichts blitzt. Siehe den Abschnitt "Das gestapelte Paar".
 * Der alte Weg bleibt als Rueckfall stehen: fuer die Galerie und fuer
 * jedes Bild, fuer das sich kein Paar SICHER bauen laesst.
 *
 * echtesGegenstueck() SUCHT stattdessen, statt zu konstruieren:
 * product-card.liquid legt auf .product-card__figure die tatsaechlich
 * vorhandenen Bild-Adressen des Produkts ab
 * (data-lunalume-bilder="a.png,,b.png,,..."). Ist diese Liste da, wird
 * das Gegenstueck darunter gesucht - das trifft auch mit UUID, weil es
 * keine Adresse erfindet, sondern eine bereits echte auswaehlt. Ohne
 * die Liste (etwa die Startseiten-Kacheln, eigene kollisionsfreie
 * Namen) faellt es auf gegenstueck() zurueck wie bisher.
 */
(function () {
  'use strict';

  var SCHLUESSEL = 'lunalume-licht';

  // '_aus' steht bewusst am Ende: die spezifischeren Muster muessen
  // zuerst greifen, sonst schlaegt es zu frueh an. Ohne Punkt am Ende -
  // treffer() haengt selbst an, wonach gesucht wird.
  var PAARE = [
    ['_oben_hell', '_oben_dunkel'],
    ['_unten_hell', '_unten_dunkel'],
    ['_kopf_hell', '_kopf_dunkel'],
    ['_flaeche_hell', '_flaeche_dunkel'],
    ['_aus', '_an']
  ];

  function istProduktbild(t) {
    return typeof t === 'string' && t.indexOf('render_') !== -1;
  }

  // Ein Stamm wie '_kopf_hell' zaehlt als Treffer, wenn direkt danach
  // ein Punkt kommt (render_Crema_kopf_hell.png) ODER ein Unterstrich
  // (render_Crema_kopf_hell_ddbd3c3c-....png, die UUID-Falle oben).
  function treffer(text, stamm) {
    return text.indexOf(stamm + '.') !== -1 || text.indexOf(stamm + '_') !== -1;
  }

  function gegenstueck(url, an) {
    if (!istProduktbild(url)) return null;
    for (var i = 0; i < PAARE.length; i++) {
      var von = an ? PAARE[i][0] : PAARE[i][1];
      var nach = an ? PAARE[i][1] : PAARE[i][0];
      if (!treffer(url, von)) continue;
      // Nur bei einem SAUBEREN Namen (Punkt direkt nach dem Stamm) laesst
      // sich das Gegenstueck durch Text-Ersetzen wirklich treffen - beide
      // Zustaende bekommen beim Hochladen UNABHAENGIGE UUIDs, "hell" und
      // "dunkel" haben also verschiedene Endungen. Eine Ersetzung wuerde
      // dann eine Adresse erfinden, die es nicht gibt (ein totes Bild ist
      // schlimmer als ein Bild, das nicht umschaltet). Bei einer UUID
      // gibt gegenstueck() deshalb bewusst auf; zustand()/treffer()
      // erkennen den Zustand trotzdem, das genuegt fuer die Galerie.
      if (url.indexOf(von + '.') === -1) return null;
      var ziel = url.split(von + '.').join(nach + '.');
      // KOLLEKTIONS-FALLE, gefunden 31.08.2026: die Kachelbilder der
      // Kollektionsseite (render_Kollektion_<Familie>_...) kommen aus dem
      // image-Feld der Shopify-Collection - dort landet nur der GERADE
      // aktive Zustand, unter /cdn/shop/collections/. Das Gegenstueck ist
      // nie als Collection-Bild gesetzt, es liegt als gewoehnliche Datei
      // unter /cdn/shop/files/ - derselbe Pfad wie jedes andere
      // hochgeladene Bild. Eine reine Text-Ersetzung des Dateinamens
      // liefert hier eine tote Adresse (404), weil sie den
      // /collections/-Pfad mitschleppt. Fuer render_Kollektion_-Dateien
      // deshalb den Pfad auf /files/ normalisieren, wo das Gegenstueck
      // wirklich liegt.
      // split/join statt replace() - hier kommt zwar je EINE Adresse an
      // (tauscheListe() zerlegt das srcset vorher), aber gegenstueck()
      // wird auch mit ganzen Attributwerten aufgerufen. replace() mit
      // String-Muster ersetzt nur das erste Vorkommen; genau daran ist
      // der erste Anlauf am 31.08.2026 gescheitert (siehe Kopf-Skript).
      if (ziel.indexOf('render_Kollektion_') !== -1) {
        ziel = ziel.split('/cdn/shop/collections/').join('/cdn/shop/files/');
      }
      return ziel;
    }
    return null;
  }

  function zustand(text) {
    if (!istProduktbild(text)) return null;
    for (var i = 0; i < PAARE.length; i++) {
      if (treffer(text, PAARE[i][1])) return 'an';
      if (treffer(text, PAARE[i][0])) return 'aus';
    }
    return null;
  }

  /* Das ECHTE Gegenstueck, gesucht statt geraten. product-card.liquid legt
   * auf .product-card__figure ein data-lunalume-bilder-Attribut mit allen
   * tatsaechlich vorhandenen Bild-Adressen des Produkts ab (28.08.2026,
   * gegen die UUID-Falle). Wird HIER etwas gefunden, ist es exakt - ein
   * Treffer aus gegenstueck() ist dagegen nur eine Vermutung, die bei
   * einer UUID gar nicht erst erfindet, sondern richtig aufgibt. */
  function echtesGegenstueck(el, url, an) {
    var host = el.closest('[data-lunalume-bilder]');
    if (!host) return null;
    var liste = host.getAttribute('data-lunalume-bilder');
    if (!liste) return null;
    var kandidaten = liste.split(',,').filter(function (s) { return s; });
    for (var i = 0; i < PAARE.length; i++) {
      var von = an ? PAARE[i][0] : PAARE[i][1];
      var nach = an ? PAARE[i][1] : PAARE[i][0];
      if (!treffer(url, von)) continue;
      for (var j = 0; j < kandidaten.length; j++) {
        if (treffer(kandidaten[j], nach)) return kandidaten[j];
      }
      return null;                     // Zustand erkannt, aber kein Gegenstueck da
    }
    return null;
  }

  /* Alles einsammeln, was den Dateinamen tragen koennte - ein faul
   * geladenes Bild hat noch kein src, aber fast immer ein srcset. */
  function kennung(el) {
    var teile = [];
    el.querySelectorAll('img, source').forEach(function (m) {
      ['src', 'srcset', 'data-src', 'data-srcset'].forEach(function (a) {
        var w = m.getAttribute(a);
        if (w) teile.push(w);
      });
      if (m.currentSrc) teile.push(m.currentSrc);
    });
    return teile.join(' ');
  }

  /* Aus einer Kennung (src, srcset, ...) die erste Produktbild-Adresse
   * herausziehen - srcset enthaelt mehrere, getrennt durch Komma und
   * Leerzeichen. */
  function erstesBild(text) {
    if (!istProduktbild(text)) return null;
    var teile = text.split(/[\s,]+/);
    for (var i = 0; i < teile.length; i++) {
      if (istProduktbild(teile[i])) return teile[i];
    }
    return null;
  }

  function inGalerie(el) {
    return !!el.closest('.product-gallery, [class*="product-gallery"]');
  }

  /* Eine srcset-Liste auf den anderen Zustand umschreiben. Jede Adresse
     einzeln - deshalb kann gegenstueck() darin gefahrlos mit split/join
     arbeiten (siehe die Kollektions-Falle dort). Findet sich zu einer
     Adresse kein Gegenstueck, bleibt SIE stehen; erfunden wird nichts.
     Getrennt von tauscheListe(), weil das gestapelte Paar dieselbe
     Umschrift braucht, ohne dabei ein Merkmal zu ueberschreiben. */
  function listeUmschreiben(el, wert, an) {
    return wert.split(',').map(function (t) {
      t = t.trim();
      var leer = t.indexOf(' ');
      var url = leer === -1 ? t : t.slice(0, leer);
      var rest = leer === -1 ? '' : t.slice(leer);
      return (echtesGegenstueck(el, url, an) || gegenstueck(url, an) || url) + rest;
    }).join(', ');
  }

  function tauscheListe(el, attr, an) {
    var wert = el.getAttribute(attr);
    if (!wert || !istProduktbild(wert)) return;
    el.setAttribute(attr, listeUmschreiben(el, wert, an));
  }

  function tauscheBild(img, an) {
    var q = img.getAttribute('src');
    if (q) {
      var neu = echtesGegenstueck(img, q, an) || gegenstueck(q, an);
      if (neu && neu !== q) img.setAttribute('src', neu);
    }
    ['srcset', 'data-srcset', 'data-src'].forEach(function (a) {
      tauscheListe(img, a, an);
    });
    var p = img.parentElement;
    if (p && p.tagName === 'PICTURE') {
      p.querySelectorAll('source').forEach(function (s) {
        ['srcset', 'data-srcset'].forEach(function (a) { tauscheListe(s, a, an); });
      });
    }
  }

  /* Die Kennung EINES Bildes - dieselben vier Merkmale wie in kennung(),
     nur am Element selbst statt an seinen Kindern. kennung() sammelt in
     einem Behaelter (Galeriefolie), hier steht das <img> schon fest. */
  function bildKennung(img) {
    return (img.getAttribute('src') || '') + ' ' +
           (img.getAttribute('srcset') || '') + ' ' +
           (img.getAttribute('data-src') || '') + ' ' +
           (img.getAttribute('data-srcset') || '');
  }

  /* Alle Kachelbilder auf den Zustand bringen.
     weich === true blendet gepaarte Bilder ueber, alles andere schaltet
     hart. Seitenaufbau und die Nachlaeufe des Beobachters rufen IMMER
     hart - siehe anwenden(). */
  function karten(an, weich) {
    document.querySelectorAll('img').forEach(function (img) {
      if (inGalerie(img)) return;
      // Das Gegenstueck eines Paares wird nie fuer sich behandelt - es
      // haengt an seinem Original und bekommt von dort seine Deckkraft.
      if (img.hasAttribute('data-licht-partner')) return;
      // Laeuft auf diesem Bild gerade eine Blende, gehoert der Tausch
      // ihr allein. Ohne diese Zeile taeuscht der Beobachter weiter
      // unten den Dimmer aus: er ruft anwenden() im Sekundentakt, das
      // riefe karten(), und mitten in die Blende hinein saesse wieder
      // genau der harte Sprung, den sie vermeiden soll.
      if (img.hasAttribute('data-licht-blende')) return;
      if (!istProduktbild(bildKennung(img))) return;
      var paar = paarFuer(img);
      if (paar) { paarSetzen(paar, an, !!weich); return; }
      tauscheBild(img, an);          // ohne Paar wie bisher
    });
  }

  function galerie(an) {
    var folien = [].slice.call(document.querySelectorAll('.product-gallery__media'));
    if (!folien.length) return;
    var thumbs = [].slice.call(document.querySelectorAll('.product-gallery__thumbnail'));
    var gewollt = an ? 'an' : 'aus';

    // VOR dem Ausblenden merken, welches Motiv gerade zu sehen ist -
    // danach ist die Folie versteckt und nicht mehr zu befragen.
    var vorher = document.querySelector('.product-gallery__media.is-selected');
    var vorherBild = vorher ? erstesBild(kennung(vorher)) : null;

    var ersteSichtbar = -1;
    folien.forEach(function (f, i) {
      var z = zustand(kennung(f));
      var zeigen = (z === null) || (z === gewollt);   // null = Video: bleibt
      f.hidden = !zeigen;
      f.style.display = zeigen ? '' : 'none';
      if (thumbs[i]) {
        thumbs[i].hidden = !zeigen;
        thumbs[i].style.display = zeigen ? '' : 'none';
      }
      if (zeigen && ersteSichtbar === -1) ersteSichtbar = i;
    });

    var aktiv = document.querySelector('.product-gallery__media.is-selected');
    if (aktiv && !aktiv.hidden) return;               // Auswahl haelt, nichts zu tun

    // BEIM MOTIV BLEIBEN. Frueher wurde hier stumpf die erste sichtbare
    // Folie gewaehlt - wer bei Bild 3 stand, landete beim Umschalten
    // wieder bei Bild 1. Jetzt wird das GEGENSTUECK der zuletzt aktiven
    // Ansicht gesucht: aus <-> an, kopf_hell <-> kopf_dunkel und so fort.
    var ziel = -1;
    if (vorherBild) {
      var gesucht = gegenstueck(vorherBild, an);
      if (gesucht) {
        var name = gesucht.split('/').pop().split('?')[0];
        for (var i = 0; i < folien.length; i++) {
          if (folien[i].hidden) continue;
          if (kennung(folien[i]).indexOf(name) !== -1) { ziel = i; break; }
        }
      }
    }
    if (ziel === -1) ziel = ersteSichtbar;            // Rueckfall
    if (ziel !== -1 && thumbs[ziel]) thumbs[ziel].click();
  }

  /* --- Die Knoepfe ins Bild haengen --------------------------------- */
  function vorlage() {
    var t = document.getElementById('ll-schalter-vorlage');
    return t ? t.content.firstElementChild.cloneNode(true) : null;
  }

  function anker() {
    // Produktkacheln auf Uebersichtsseiten + jede Galeriefolie.
    // Beide sind im Theme relativ positioniert, taugen also als Anker.
    var a = [].slice.call(document.querySelectorAll('.product-card__figure'));
    var b = [].slice.call(document.querySelectorAll('.product-gallery__media'));
    return a.concat(b);
  }

  function knoepfeSetzen() {
    var gesetzt = 0;
    anker().forEach(function (el) {
      if (el.querySelector(':scope > [data-lichtschalter]')) return;
      // Nur dort, wo wirklich ein Studiobild liegt - Videos und
      // Fremdbilder bekommen keinen Schalter.
      if (zustand(kennung(el)) === null) return;
      var k = vorlage();
      if (!k) return;
      if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
      el.appendChild(k);
      gesetzt++;
    });

    // RUECKFALL. Auf Seiten ohne Produktbilder - "Fragen & Antworten",
    // "Ueber uns", Kontakt, Warenkorb - gaebe es sonst gar keinen
    // Schalter. Wer dort landet, kaeme aus dem Dunkelmodus nicht mehr
    // heraus, weil die Wahl ueber den Seitenwechsel haelt. Also ein
    // schwebender Schalter, sobald keiner im Bild sitzt.
    var vorhanden = document.querySelectorAll('[data-lichtschalter]').length;
    if (vorhanden === 0) {
      var f = vorlage();
      if (f) {
        f.classList.add('ll-schalter--schwebend');
        document.body.appendChild(f);
      }
    } else if (vorhanden > 1) {
      var s = document.querySelector('.ll-schalter--schwebend');
      if (s) s.remove();          // Bilder da - der schwebende kann weg
    }
  }

  /* --- Trustpilot ---------------------------------------------------
   * Das Widget steckt in einem Rahmen von trustpilot.com - sein Inneres
   * ist von hier aus nicht erreichbar (fremde Herkunft). Umfaerben kann
   * es nur Trustpilot selbst ueber data-theme; danach muss das Widget
   * neu geladen werden.
   * Der Link geht auf das geprueftes Profil von Lunalume; er liegt als
   * durchsichtige Flaeche DARUEBER, weil der Rahmen Klicks schluckt.
   */
  var TRUSTPILOT = 'https://de.trustpilot.com/review/lunalume.de';

  function trustpilot(an) {
    document.querySelectorAll('.trustpilot-widget').forEach(function (w) {
      // Link nur einmal anlegen.
      if (!w.parentElement.classList.contains('ll-trustpilot-huelle')) {
        var huelle = document.createElement('div');
        huelle.className = 'll-trustpilot-huelle';
        w.parentElement.insertBefore(huelle, w);
        huelle.appendChild(w);
        var a = document.createElement('a');
        a.className = 'll-trustpilot-link';
        a.href = TRUSTPILOT;
        a.target = '_blank';
        a.rel = 'noopener';
        a.setAttribute('aria-label', 'Lunalume auf Trustpilot ansehen');
        huelle.appendChild(a);
      }
      // LESBARKEIT UEBER EINE HELLE AUFLAGE, nicht ueber data-theme.
      //
      // Frueher stand hier `an ? 'dark' : 'light'`. Zwei Fehler darin:
      //
      // 1. Es folgte dem Schalter statt dem Grund. Die
      //    Ankuendigungsleiste hat einen fest gesetzten Grund von
      //    rgb(26,26,26) - Helligkeit 0,01 - AUCH im hellen Modus. Das
      //    Abzeichen war dort seit jeher unlesbar, nicht erst seit dem
      //    Lichtschalter. Die Fusszeile dagegen steht hell. Ein
      //    einziger Wert kann fuer beide gar nicht stimmen.
      //
      // 2. data-theme hilft hier ueberhaupt nicht. Dreimal nachgeprueft
      //    - Attribut gesetzt, Rahmen entfernt und neu geladen, Widget
      //    komplett neu aufgesetzt: der Rahmen laedt mit theme=dark,
      //    der Schriftzug bleibt dunkel (#191919). Diese Vorlage kennt
      //    keine helle Fassung.
      //
      // Also wird nicht das Widget umgefaerbt, sondern ihm ein heller
      // Grund untergelegt - dort, wo der Grund dunkel ist.
      //
      // GEMESSEN WIRD DER ELTERNTEIL DER HUELLE, nicht das Widget. Traegt
      // die Huelle die Auflage, ist der Grund direkt ueber dem Widget
      // weiss; eine Messung am Widget wuerde die Auflage wieder
      // abschalten, im naechsten Durchlauf erneut setzen, und so fort.
      var huelle = w.parentElement;
      var bezug = huelle.parentElement;
      var hg = bezug ? grundHelligkeit(bezug) : null;
      var braucht = (hg !== null && hg < 0.42);
      huelle.classList.toggle('ll-trustpilot-huelle--hell', braucht);
    });
  }

  /* --- Nachzuegler: fest verdrahtete Textfarben ----------------------
   *
   * Manche Bausteine setzen ihre Farbe DIREKT am Element statt ueber die
   * Theme-Variablen - die Vertrauensbox auf der Produktseite steht auf
   * rgb(18,18,18), die Seite "Fragen & Antworten" aehnlich. Der
   * Variablentausch erreicht sie nicht, und im Dunkelmodus stand dunkle
   * Schrift auf dunklem Grund.
   *
   * Hier wird deshalb gemessen statt geraten: fuer jedes Element mit
   * eigenem Text wird die Helligkeit der Schrift bestimmt UND die des
   * ersten Vorfahren, der wirklich eine Hintergrundfarbe hat. Nur wenn
   * BEIDE dunkel sind, wird die Schrift aufgehellt. Elemente auf hellem
   * Grund - Knoepfe, weisse Karten - bleiben unangetastet.
   *
   * Zurueckgenommen wird ueber ein Merkmal am Element, damit beim
   * Ausschalten nichts haengen bleibt.
   */
  function helligkeit(farbe) {
    var m = /rgba?\(([^)]+)\)/.exec(farbe || '');
    if (!m) return null;
    var v = m[1].split(',').map(parseFloat);
    if (v.length > 3 && v[3] === 0) return null;          // durchsichtig
    return (0.2126 * v[0] + 0.7152 * v[1] + 0.0722 * v[2]) / 255;
  }

  function grundHelligkeit(el) {
    var p = el;
    while (p && p !== document.documentElement) {
      var h = helligkeit(getComputedStyle(p).backgroundColor);
      if (h !== null) return h;
      p = p.parentElement;
    }
    return null;
  }

  function nachzuegler(an) {
    if (!an) {
      document.querySelectorAll('[data-licht-schrift]').forEach(function (e) {
        e.style.color = '';
        e.removeAttribute('data-licht-schrift');
      });
      // Auch die Pruefvermerke loeschen, damit ein spaeteres Einschalten
      // wieder frisch misst.
      document.querySelectorAll('[data-licht-geprueft]').forEach(function (e) {
        e.removeAttribute('data-licht-geprueft');
      });
      return;
    }
    var alle = document.querySelectorAll('p, span, li, td, th, dd, dt, h1, h2, h3, h4, h5, h6, a, label, small, strong, em, summary, div');
    for (var i = 0; i < alle.length; i++) {
      var e = alle[i];
      if (e.closest('.ll-schalter')) continue;
      if (e.hasAttribute('data-licht-schrift')) continue;
      // WARUM AUCH DIE VERWORFENEN VERMERKT WERDEN. Der Beobachter ruft
      // anwenden() bei jeder fremden Klassenaenderung - gemessen rund
      // einmal je Sekunde, auch wenn der Nutzer nichts tut. Ohne diesen
      // Vermerk wuerde jedes Mal die ganze Seite neu durchgerechnet:
      // getComputedStyle je Element plus Aufstieg durch die Eltern. Der
      // alte Vermerk allein reichte nicht, denn er sitzt nur auf den
      // GEAENDERTEN - die grosse Mehrheit wurde jedes Mal neu geprueft.
      if (e.hasAttribute('data-licht-geprueft')) continue;
      // Nur Elemente mit eigenem Text, nicht blosse Huellen.
      var eigen = false;
      for (var k = 0; k < e.childNodes.length; k++) {
        if (e.childNodes[k].nodeType === 3 && e.childNodes[k].nodeValue.trim()) { eigen = true; break; }
      }
      if (!eigen) continue;
      e.setAttribute('data-licht-geprueft', 'ja');
      var hs = helligkeit(getComputedStyle(e).color);
      if (hs === null || hs > 0.42) continue;             // Schrift nicht dunkel
      var hg = grundHelligkeit(e);
      if (hg === null || hg > 0.42) continue;             // Grund nicht dunkel
      e.style.color = 'rgb(240 233 221)';
      e.setAttribute('data-licht-schrift', 'ja');
    }
  }

  /* --- Das gestapelte Paar ==========================================
   *
   * Vorbild incommonwith.com, am Live-DOM gemessen (31.08.2026):
   *
   *   <div class="relative aspect-[29/36]">
   *     <figure class="absolute inset-0 w-full h-full ... opacity-0">   Aus
   *     <figure class="absolute inset-0 w-full h-full ... opacity-100"> An
   *   </div>
   *
   * Beide Zustaende liegen gleichzeitig da, der Schalter kippt nur die
   * Deckkraft - gegenlaeufig, so dass man waehrend der Blende beide
   * zugleich sieht. Gemessene Uhr auf den figure-Elementen:
   *     transform 0.4s cubic-bezier(0.4, 0, 0.2, 1),
   *     opacity   1.2s cubic-bezier(0.42, 0, 0.58, 1)
   * Sie steht im Kopfteil als CSS-Regel auf [data-licht-paar]; hier wird
   * nur die Deckkraft gesetzt. Das ist Absicht: eine Blende, die allein
   * aus zwei Endwerten besteht, KANN nichts Halbes hinterlassen - der
   * Endwert steht als Merkmal am Element, nicht in einer Animation, und
   * ein Umschalten mittendrin zielt einfach neu.
   *
   * GEBAUT WIRD NUR, WENN ES SICHER IST. Ein erfundenes Gegenstueck
   * waere ein totes Bild, und das ist schlimmer als eines, das nicht
   * umschaltet. Sechs Bedingungen, und bei jeder Absage bleibt alles
   * beim Alten (harter Tausch bzw. der Dimmer weiter unten):
   *
   *   1. Die Adresse ist bekannt und traegt einen erkennbaren Zustand.
   *   2. echtesGegenstueck() oder gegenstueck() liefert eine Adresse.
   *      Bei UUID-Namen gibt gegenstueck() bewusst auf - dann kein Paar.
   *   3. Das Bild ist in Ruhe sichtbar. Das ZWEITE Kachelbild
   *      (product-card__image--secondary) liegt mit Deckkraft 0 da und
   *      wird vom Theme erst beim Darueberfahren eingeblendet. Ein Paar
   *      naehme dem Theme genau diese Deckkraft aus der Hand und der
   *      Hover-Wechsel waere tot. Es wird weiter hart getauscht - man
   *      sieht das nicht, weil es beim Tausch unsichtbar ist.
   *   4. Im selben Elternteil liegt noch kein Gegenstueck (dieselbe
   *      Absicherung, von der anderen Seite her).
   *   5. Es gibt einen Vorfahren, dessen INNENkasten dem Bild auf 2 px
   *      genau entspricht. Nur dann deckt inset:0 wirklich das Bild -
   *      und nur dann kann sich beim Anlegen nichts verschieben.
   *   6. Auf dem Bild laeuft keine alte Blende.
   *
   * EINGEHAENGT wird direkt hinter dem Bild (bzw. hinter seinem
   * <picture>), NICHT in einer neuen Huelle. `.content-over-media > img`
   * im Theme und `.product-card__figure img` im Letterbox-Fix des
   * Kopfteils bauen auf die Stellung im Baum; eine Huelle haette beide
   * still ausgehebelt - helle Letterbox-Balken im Dunkelmodus, genau der
   * Fehler, der heute Vormittag schon einmal dastand.
   *
   * Der BEZUG - der positionierte Vorfahr, an dem inset:0 haengt - ist
   * davon unabhaengig. Er wird GESUCHT, nicht gesetzt: auf der
   * Produktkachel liegt das Bild in einem <a>, positioniert ist erst
   * .product-card__figure darueber. Nur wenn gar kein passender
   * positionierter Vorfahr da ist, wird der naechste deckungsgleiche
   * relativ gemacht - das verschiebt nichts, es macht nur einen Bezug auf.
   *
   * DIE KLASSEN DES ORIGINALS werden mitkopiert, dazu object-fit,
   * object-position und die Rundung aus dem gerechneten Stil. Nur so
   * sehen beide Bilder gleich aus und der Hover-Zoom des Themes fasst
   * beide an - sonst zoomte das untere und das obere bliebe stehen.
   */

  var PAAR_TOLERANZ = 2;              // px - Sub-Pixel-Layouts
  var PAAR_VERSUCHE = 5;              // danach nicht mehr nachfragen

  function sichtbar(el) {
    var w = parseFloat(getComputedStyle(el).opacity);
    return !isFinite(w) || w > 0.99;
  }

  /* Der Kasten des Ankers gegen den INNENkasten (padding box) des
     Bezugs - genau die Flaeche, die ein absolutes inset:0 spaeter
     ausfuellt. clientWidth/Height sind dieser Innenkasten, seine Ecke
     liegt um die Rahmenbreite versetzt. */
  function deckungsgleich(anker, bezug) {
    var w = bezug.clientWidth, h = bezug.clientHeight;
    if (!w || !h) return false;
    var a = anker.getBoundingClientRect();
    if (!a.width || !a.height) return false;
    var b = bezug.getBoundingClientRect();
    var cs = getComputedStyle(bezug);
    var l = b.left + (parseFloat(cs.borderLeftWidth) || 0);
    var t = b.top + (parseFloat(cs.borderTopWidth) || 0);
    return Math.abs(a.left - l) <= PAAR_TOLERANZ &&
           Math.abs(a.top - t) <= PAAR_TOLERANZ &&
           Math.abs(a.width - w) <= PAAR_TOLERANZ &&
           Math.abs(a.height - h) <= PAAR_TOLERANZ;
  }

  /* Am liebsten ein Vorfahr, der ohnehin schon positioniert ist - dann
     wird am Theme gar nichts angefasst (.product-card__figure ist es,
     knoepfeSetzen() sorgt notfalls selbst dafuer). Sonst der naechste
     deckungsgleiche darunter, der relativ gemacht werden darf; UEBER
     den ersten positionierten Vorfahren hinaus waere position:relative
     wirkungslos, dort wird abgebrochen.

     GEMESSEN WIRD IMMER DAS BILD, gesucht wird ab dem Elternteil des
     ANKERS - und das sind bei einem <picture> zwei verschiedene Dinge.
     Ein <picture> ist von Haus aus `display: inline`: sein Kasten ist
     eine Zeilenbox, am Pruefstand 240x19 px am unteren Rand, waehrend
     das Bild darin 240x380 fuellt. Wer das picture misst, verwirft jedes
     picture als "nicht deckungsgleich". Fuer den Bezug ist das picture
     ohnehin egal - es ist statisch, das Gegenstueck haengt am ersten
     positionierten Vorfahren darueber. */
  function bezugFinden(mass, start) {
    var p = start, tiefe = 0, kandidat = null;
    while (p && p !== document.body && tiefe < 5) {
      var gleich = deckungsgleich(mass, p);
      if (getComputedStyle(p).position !== 'static') {
        if (gleich) return p;
        break;
      }
      if (gleich && !kandidat) kandidat = p;
      p = p.parentElement;
      tiefe++;
    }
    if (!kandidat) return null;
    kandidat.style.position = 'relative';
    return kandidat;
  }

  /* hart = strukturell, kommt nicht wieder. weich = vielleicht spaeter
     (noch nicht gelayoutet, Maus gerade darueber). Auch die weiche
     Absage gibt irgendwann auf - sonst rechnet der Beobachter im
     Sekundentakt dieselbe Absage neu. */
  function paarAbsage(img, hart) {
    if (hart) { img.llPaarNein = true; return null; }
    img.llPaarVersuch = (img.llPaarVersuch || 0) + 1;
    if (img.llPaarVersuch >= PAAR_VERSUCHE) img.llPaarNein = true;
    return null;
  }

  function paarFuer(img) {
    if (img.llPaar) return img.llPaar;
    if (img.llPaarNein) return null;
    if (img.hasAttribute('data-licht-partner')) return null;
    if (img.hasAttribute('data-licht-blende')) return null;   // alte Blende zuerst
    return paarBauen(img);
  }

  function paarBauen(img) {
    var url = erstesBild(bildKennung(img));
    if (!url) return paarAbsage(img, false);
    var z = zustand(url);
    if (z === null) return paarAbsage(img, false);

    // Das Gegenstueck ist der jeweils andere Zustand: steht das Bild auf
    // 'aus', wird nach 'an' gesucht - genau die Richtung, die
    // echtesGegenstueck()/gegenstueck() mit an === true meinen.
    var nachAn = (z === 'aus');
    var gegen = echtesGegenstueck(img, url, nachAn) || gegenstueck(url, nachAn);
    if (!gegen) return paarAbsage(img, true);        // NICHTS erfinden
    if (!sichtbar(img)) return paarAbsage(img, false);

    var anker = (img.parentElement && img.parentElement.tagName === 'PICTURE')
              ? img.parentElement : img;
    var eltern = anker.parentElement;
    if (!eltern) return paarAbsage(img, false);
    if (eltern.querySelector(':scope > [data-licht-partner]')) return paarAbsage(img, true);

    var bezug = bezugFinden(img, eltern);
    if (!bezug) return paarAbsage(img, false);

    // Reste einer alten Blende wegraeumen: eine Animation mit
    // fill:'forwards' schlaegt jede Deckkraft aus dem Merkmal.
    if (img.llAnim) { try { img.llAnim.cancel(); } catch (e) { } img.llAnim = null; }

    var stil = getComputedStyle(img);
    var p = document.createElement('img');
    if (img.className) p.className = img.className;
    ['sizes', 'width', 'height', 'loading'].forEach(function (nm) {
      var v = img.getAttribute(nm);
      if (v) p.setAttribute(nm, v);
    });
    var liste = img.getAttribute('srcset') || img.getAttribute('data-srcset');
    if (liste && istProduktbild(liste)) {
      p.setAttribute('srcset', listeUmschreiben(img, liste, nachAn));
    }
    p.setAttribute('src', gegen);
    if (!p.getAttribute('loading')) p.setAttribute('loading', 'lazy');
    p.setAttribute('decoding', 'async');
    p.setAttribute('fetchpriority', 'low');   // das Original hat Vorrang
    p.setAttribute('alt', '');                // Dublette, nicht vorlesen
    p.setAttribute('aria-hidden', 'true');
    p.style.objectFit = stil.objectFit;
    p.style.objectPosition = stil.objectPosition;
    p.style.borderRadius = stil.borderRadius;
    p.setAttribute('data-licht-partner', nachAn ? 'an' : 'aus');
    p.setAttribute('data-licht-paar', 'oben');

    // OHNE BLENDE ANLEGEN. data-licht-sofort schaltet die Transition ab;
    // nach einem erzwungenen Anstrich darf sie zurueck. Der erste
    // Anstrich der Seite darf NIE blenden - siehe das Kopf-Skript.
    p.setAttribute('data-licht-sofort', 'ja');
    anker.setAttribute('data-licht-sofort', 'ja');
    p.style.opacity = '0';                    // das Original zeigt noch
    img.style.opacity = '1';
    anker.setAttribute('data-licht-paar', 'unten');
    eltern.insertBefore(p, anker.nextSibling);
    void p.offsetWidth;
    p.removeAttribute('data-licht-sofort');
    anker.removeAttribute('data-licht-sofort');

    var paar = {
      anker: anker,
      unten: img, untenStand: z,
      oben: p,    obenStand: nachAn ? 'an' : 'aus',
      ziel: z,                                // was gerade zu sehen ist
      uhr: null, wartet: null, los: null
    };
    img.llPaar = paar;
    p.llPaar = paar;
    return paar;
  }

  function paarWartenBeenden(paar) {
    if (paar.uhr) { clearTimeout(paar.uhr); paar.uhr = null; }
    if (paar.wartet && paar.los) {
      paar.wartet.removeEventListener('load', paar.los);
      paar.wartet.removeEventListener('error', paar.los);
    }
    paar.wartet = null;
    paar.los = null;
  }

  function paarSofort(paar, ein) {
    var e = [paar.anker, paar.oben];
    for (var i = 0; i < e.length; i++) {
      if (ein) e[i].setAttribute('data-licht-sofort', 'ja');
      else e[i].removeAttribute('data-licht-sofort');
    }
  }

  /* Umschalten heisst hier: zwei Merkmale setzen. Mehr nicht.
     Steht das Paar schon auf dem Ziel (oder laeuft dorthin), passiert
     nichts - genau das braucht der Beobachter, der anwenden() im
     Sekundentakt ruft und sonst jede Blende zerhacken wuerde. */
  function paarSetzen(paar, an, weich) {
    var gewollt = an ? 'an' : 'aus';
    if (paar.ziel === gewollt) return;
    paar.ziel = gewollt;
    paarWartenBeenden(paar);

    var obenAn = (paar.obenStand === gewollt);

    function stellen() {
      paarWartenBeenden(paar);
      if (paar.ziel !== gewollt) return;      // inzwischen weitergeschaltet
      paar.oben.style.opacity = obenAn ? '1' : '0';
      paar.unten.style.opacity = obenAn ? '0' : '1';
    }

    if (!weich) {
      paarSofort(paar, true);
      stellen();
      void paar.oben.offsetWidth;             // Anstrich erzwingen
      paarSofort(paar, false);
      return;
    }

    // ERST GELADEN, DANN BLENDEN. Im Regelfall stehen beide Bilder
    // laengst - sie liegen ja seit dem Seitenaufbau da, das ist der
    // ganze Sinn des Stapels. Nur ein Paar, das genau jetzt erst
    // entstanden ist, koennte noch leer sein; darauf zu blenden blitzt
    // weiss. Geduld hat eine Grenze.
    var kommt = obenAn ? paar.oben : paar.unten;
    if (kommt.complete) { stellen(); return; }
    paar.los = function () { stellen(); };
    paar.wartet = kommt;
    kommt.addEventListener('load', paar.los);
    kommt.addEventListener('error', paar.los);
    paar.uhr = setTimeout(paar.los, BLENDE_GEDULD);
  }

  /* --- Der Dimmer: die Bilder ueberblenden ===========================
   *
   * Wunsch des Nutzers, 31.08.2026: "cool waere wie es langsam von hell
   * in dunkel umwandelt und nicht so ruck artig". Grund und Schrift
   * blenden laengst weich (html body { transition: ... } im Kopfteil) -
   * die BILDER sprangen hart, weil hier einfach src/srcset getauscht
   * wurde.
   *
   * VIER DINGE, die dabei schiefgehen, und die Antworten darauf:
   *
   * 1. Auf ein noch nicht geladenes Bild blenden - das blitzt weiss.
   *    Deshalb wird getauscht, WAEHREND das Bild unsichtbar ist, und
   *    erst nach dessen load-Ereignis wieder eingeblendet. Mit
   *    Geduldsgrenze: ein nie ladendes Bild darf nicht unsichtbar
   *    haengen bleiben.
   * 2. Beim SEITENAUFBAU blenden waere ein Rueckschritt - das
   *    Kopf-Skript setzt die richtige Adresse absichtlich vor dem
   *    ersten Anstrich, damit nichts aufblitzt. Geblendet wird nur beim
   *    aktiven Umschalten: anwenden(an, true), und das ruft allein der
   *    Klick auf den Schalter. Der Beobachter ruft weiter anwenden(an)
   *    ohne zweites Merkmal - hart, wie bisher.
   * 3. Halb durchsichtige Reste bei schnellem Hin und Her. Deshalb
   *    Web-Animations statt style.opacity: je Element genau EIN
   *    Animationsobjekt, das weiterbenutzt statt ersetzt wird, und am
   *    Ende entfernt. Die Deckkraft steht danach wieder im CSS und
   *    nicht am Element - sie KANN nicht haengen bleiben.
   * 4. Die Galerie laesst sich nicht Bild fuer Bild ueberblenden: sie
   *    tauscht nicht, sie blendet Folien ein und aus und zieht das
   *    Karussell nach. Also blendet sie als GANZES weg und wieder her,
   *    der Karussellsprung passiert unsichtbar. An der Karussell-Logik
   *    selbst aendert sich nichts.
   *
   * Warum ein data-Merkmal und keine Klasse fuer den Laufvermerk: der
   * Beobachter unten hoert auf 'class'. Eine Klasse waehrend der Blende
   * wuerde ihn bei jedem Umschalten zusaetzlich wecken.
   */

  /* Die EINE Uhr des Dimmers steht im Kopfteil als --ll-dimmer, damit
     Grund, Schrift und Bilder nicht auseinanderlaufen. Hier nur der
     Rueckfall, falls die Variable fehlt oder Unfug enthaelt. */
  var DIMMER = 420;
  var DIMMER_KURVE = 'cubic-bezier(0.4, 0, 0.2, 1)';
  var BLENDE_AUS = 189;               // wird aus DIMMER berechnet
  var BLENDE_EIN = 231;
  var BLENDE_GEDULD = 900;            // laenger warten wir auf kein Bild

  function dimmerLesen() {
    var wert = '', kurve = '';
    try {
      var s = getComputedStyle(document.documentElement);
      wert = (s.getPropertyValue('--ll-dimmer') || '').trim();
      kurve = (s.getPropertyValue('--ll-dimmer-kurve') || '').trim();
    } catch (e) { /* die Rueckfallwerte oben stehen schon */ }
    var n = parseFloat(wert);
    // '0.42s' und '420ms' meinen dasselbe, parseFloat sieht das nicht.
    if (wert.slice(-2) !== 'ms' && wert.slice(-1) === 's') n *= 1000;
    if (isFinite(n) && n >= 80 && n <= 2000) DIMMER = n;
    // Eine unbekannte Kurve laesst animate() mit TypeError fallen -
    // deshalb nur durchlassen, was sicher geht.
    if (/^(linear|ease|ease-in|ease-out|ease-in-out|cubic-bezier\([-0-9.,\s]+\))$/.test(kurve)) {
      DIMMER_KURVE = kurve;
    }
    // Aus und Ein teilen sich die eine Uhr: der kuerzere Weg ins
    // Unsichtbare, der laengere zurueck. Zusammen genau so lang wie der
    // Farbwechsel des Grundes - beides ist derselbe Dimmer.
    BLENDE_AUS = Math.round(DIMMER * 0.45);
    BLENDE_EIN = DIMMER - BLENDE_AUS;
  }

  function blendenMoeglich() {
    if (!document.documentElement.animate) return false;
    try {
      if (window.matchMedia &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    } catch (e) { /* ohne matchMedia wird geblendet */ }
    return true;
  }

  function deckkraft(el) {
    var w = parseFloat(getComputedStyle(el).opacity);
    return (isFinite(w) && w >= 0 && w <= 1) ? w : 1;
  }

  /* JE ELEMENT GENAU EIN ANIMATIONSOBJEKT, weiterbenutzt statt ersetzt.
     Zwei Deckkraft-Animationen auf demselben Element ueberlagern sich
     in der Reihenfolge ihrer Erzeugung - die aeltere haelt dann mit
     fill:'forwards' das Bild fuer immer unsichtbar fest. Genau der
     halbtransparente Rest, den schnelles Hin und Her sonst hinterlaesst. */
  function animieren(el, von, bis, dauer) {
    var takt = { duration: Math.max(1, dauer), easing: DIMMER_KURVE, fill: 'forwards' };
    var stufen = [{ opacity: von }, { opacity: bis }];
    var alt = el.llAnim;
    if (alt && alt.effect && alt.effect.setKeyframes) {
      try {
        alt.cancel();
        alt.effect.setKeyframes(stufen);
        alt.effect.updateTiming(takt);
        alt.play();
        return alt;
      } catch (e) { /* dann eben ein neues */ }
    }
    var neu = el.animate(stufen, takt);
    // Erst das neue anlegen, dann das alte abraeumen - andersherum
    // faellt die Deckkraft fuer einen Anstrich auf 1 zurueck und es
    // blitzt.
    if (alt) { try { alt.cancel(); } catch (e) { } }
    el.llAnim = neu;
    return neu;
  }

  var laufende = [];                  // Elemente mit laufender Blende
  var blendeZiel = null;              // Zustand, auf den sie zulaufen

  /* Ein Element weich umstellen.
   *   tun()       - der harte Wechsel; laeuft im unsichtbaren Moment
   *   warteAuf()  - wird NACH tun() gerufen und gibt das <img> zurueck,
   *                 auf dessen Laden vor dem Einblenden gewartet wird
   *                 (oder null)
   * Der Wechsel findet IMMER statt: auch bei Abbruch, auch wenn das
   * neue Bild nie laedt. Eine Blende darf nie der Grund sein, dass ein
   * Bild im falschen Zustand oder unsichtbar stehen bleibt. */
  function weicherWechsel(el, tun, warteAuf) {
    if (el.llBlende) el.llBlende.stopp(true);   // true = Deckkraft stehen lassen

    var uhren = [];
    var wartet = null;
    var getan = false, vorbei = false, blendetEin = false;

    function tunEinmal() {
      if (getan) return;
      getan = true;
      // Ein Fehler im Wechsel darf die Blende nicht anhalten: ein
      // unsichtbar haengendes Bild waere schlimmer als eines im
      // falschen Zustand. Also auffangen und weiter einblenden.
      try { tun(); } catch (e) { }
    }

    function uhr(ms, was) { uhren.push(setTimeout(was, ms)); }

    function loesen(zurueck) {
      for (var i = 0; i < uhren.length; i++) clearTimeout(uhren[i]);
      uhren.length = 0;
      if (wartet) {
        wartet.removeEventListener('load', bereit);
        wartet.removeEventListener('error', bereit);
        wartet = null;
      }
      var k = laufende.indexOf(el);
      if (k !== -1) laufende.splice(k, 1);
      if (el.llBlende === steuerung) el.llBlende = null;
      el.removeAttribute('data-licht-blende');
      // Animation weg heisst: die Deckkraft kommt wieder aus dem CSS,
      // also exakt 1. Nur bei der Uebergabe an die naechste Blende
      // bleibt sie stehen, damit dort nichts aufpoppt.
      if (zurueck && el.llAnim) { try { el.llAnim.cancel(); } catch (e) { } }
    }

    var steuerung = {
      stopp: function (uebergabe) {
        if (vorbei) return;
        vorbei = true;
        tunEinmal();
        loesen(!uebergabe);
      }
    };

    el.llBlende = steuerung;
    el.setAttribute('data-licht-blende', 'ja');
    laufende.push(el);

    // Von der AKTUELLEN Deckkraft aus, nicht von 1: uebernimmt eine
    // Blende von einer laufenden, wird der Weg entsprechend kuerzer -
    // sonst poppt das Bild erst auf und verschwindet dann wieder.
    var jetzt = deckkraft(el);
    var wegAus = Math.max(40, Math.round(BLENDE_AUS * jetzt));
    animieren(el, jetzt, 0, wegAus);

    uhr(wegAus, function () {
      if (vorbei) return;
      tunEinmal();
      // ERST LADEN, DANN EINBLENDEN. Wer sofort einblendet, blendet auf
      // ein noch leeres Bild - und genau das blitzt weiss.
      var w = warteAuf ? warteAuf() : null;
      if (w && !w.complete) {
        wartet = w;
        w.addEventListener('load', bereit);
        w.addEventListener('error', bereit);     // kaputt ist auch fertig
        uhr(BLENDE_GEDULD, bereit);              // Geduld hat eine Grenze
      } else {
        bereit();
      }
    });

    function bereit() {
      if (vorbei || blendetEin) return;
      blendetEin = true;
      var d = deckkraft(el);
      var wegEin = Math.max(40, Math.round(BLENDE_EIN * (1 - d)));
      animieren(el, d, 1, wegEin);
      uhr(wegEin + 40, function () {
        vorbei = true;
        loesen(true);          // Animation entfernen -> Deckkraft exakt 1
      });
    }
  }

  function blendenAbbrechen() {
    for (var i = laufende.length - 1; i >= 0; i--) {
      var s = laufende[i].llBlende;
      if (s) s.stopp(false);
      else laufende.splice(i, 1);
    }
    blendeZiel = null;
  }

  /* Wechselt dieses Bild ueberhaupt? Nur dann lohnt eine Blende - sonst
     blendet man Bilder, die hinterher genauso aussehen wie vorher. */
  function wechselt(img, an) {
    var url = erstesBild(bildKennung(img));
    if (!url) return false;
    if (zustand(url) === (an ? 'an' : 'aus')) return false;   // steht schon richtig
    return !!(echtesGegenstueck(img, url, an) || gegenstueck(url, an));
  }

  /* Der kleinste Kasten, der Folien UND Vorschaubilder umfasst. Findet
     sich keiner in sechs Schritten, wird lieber hart geschaltet als die
     halbe Seite weggeblendet. */
  function galerieWurzel() {
    var f = document.querySelector('.product-gallery__media');
    if (!f) return null;
    var t = document.querySelector('.product-gallery__thumbnail');
    var el = f.parentElement, tiefe = 0;
    while (el && el !== document.body && tiefe < 6) {
      if (!t || el.contains(t)) return el;
      el = el.parentElement;
      tiefe++;
    }
    return null;
  }

  function galerieWechselt(an) {
    var gewollt = an ? 'an' : 'aus';
    var folien = document.querySelectorAll('.product-gallery__media');
    for (var i = 0; i < folien.length; i++) {
      if (folien[i].hidden) continue;
      var z = zustand(kennung(folien[i]));
      if (z !== null && z !== gewollt) return true;
    }
    return false;
  }

  function blendeStarten(an) {
    blendeZiel = an;

    document.querySelectorAll('img').forEach(function (img) {
      if (inGalerie(img)) return;
      if (img.hasAttribute('data-licht-partner')) return;
      if (!istProduktbild(bildKennung(img))) return;

      var laueft = img.hasAttribute('data-licht-blende');

      // DER NEUE WEG: gestapeltes Paar, es kippt nur die Deckkraft.
      // Beide Zustaende liegen dabei uebereinander, man sieht waehrend
      // der Blende beide zugleich.
      if (!laueft) {
        var paar = paarFuer(img);
        if (paar) { paarSetzen(paar, an, true); return; }
      }

      // RUECKFALL: der alte Weg - aus, tauschen, wieder ein. Fuer alles,
      // wofuer sich kein Paar sicher bauen liess.
      // Die gerade blendenden IMMER mitnehmen, auch wenn fuer sie
      // diesmal nichts zu wechseln waere: sonst bleibt beim schnellen
      // Hin und Her eines halb durchsichtig stehen, weil niemand mehr
      // seine Blende zu Ende bringt.
      if (!laueft && !wechselt(img, an)) return;
      // Was das Theme versteckt haelt, darf eine Blende nicht
      // hervorholen: das zweite Kachelbild liegt mit Deckkraft 0 da und
      // wuerde vom Einblenden fuer einen Moment sichtbar. Es wird hart
      // getauscht - unsichtbar, also unsichtbar getauscht.
      if (!laueft && !sichtbar(img)) { tauscheBild(img, an); return; }
      weicherWechsel(img, function () { tauscheBild(img, an); },
                     function () { return img; });
    });

    var g = galerieWurzel();
    if (g && (g.hasAttribute('data-licht-blende') || galerieWechselt(an))) {
      weicherWechsel(g, function () { galerie(an); }, function () {
        // Die Folie, die danach vorne steht - ihr Bild war bis eben
        // ausgeblendet und ist womoeglich noch gar nicht geladen.
        var f = document.querySelector('.product-gallery__media.is-selected');
        return f ? f.querySelector('img') : null;
      });
    } else {
      galerie(an);
    }

    // Sicherheitsnetz: was keine Blende bekommen hat, muss trotzdem
    // stimmen. karten() ueberspringt alles mit laufender Blende, und
    // ein Paar, das schon auf dem Ziel steht, ruehrt es nicht an.
    karten(an, true);
  }

  function anwenden(an, weich) {
    // ZUERST das Merkmal, DANN alles andere. Die Reihenfolge ist nicht
    // Geschmack, sondern noetig: der Kopfteil im <head> haelt einen
    // Beobachter, der Bildadressen auf die dunkle Fassung zieht,
    // solange data-licht auf 'an' steht. Stand das Setzen wie frueher
    // am ENDE, dann setzte karten(false) beim Ausschalten die hellen
    // Adressen, waehrend das Merkmal noch 'an' war - der Beobachter
    // zog sie sofort zurueck auf dunkel, das naechste anwenden() wieder
    // hell, und so fort. Der Anstrich kam dabei nicht zur Ruhe:
    // gemessen zwei Uebergaenge mit playState 'running' und currentTime
    // 0, also endlos neu gestartet. Sichtbar als dunkler Grund mit
    // dunkler Schrift ueber mehrere Sekunden nach dem Ausschalten.
    document.documentElement.setAttribute('data-licht', an ? 'an' : 'aus');
    // Geblendet wird NUR beim aktiven Umschalten (weich === true, das
    // ruft allein der Klick). Seitenaufbau und die Nachlaeufe des
    // Beobachters schalten hart - dort waere eine Blende keine
    // Weichheit, sondern ein Aufblitzen.
    if (weich && blendenMoeglich()) {
      blendeStarten(an);
    } else {
      // Ein harter Wechsel in einen ANDEREN Zustand als den, auf den
      // gerade geblendet wird, muss die Blende abbrechen - sonst zoege
      // sie ihn gleich wieder zurueck. Derselbe Zustand laesst sie
      // laufen, dafuer ist sie da.
      if (laufende.length && blendeZiel !== an) blendenAbbrechen();
      karten(an, false);
      galerie(an);
    }
    trustpilot(an);
    nachzuegler(an);
    document.querySelectorAll('[data-lichtschalter]').forEach(function (b) {
      b.setAttribute('aria-checked', an ? 'true' : 'false');
      var t = b.querySelector('[data-lichtschalter-text]');
      if (t) t.textContent = an ? 'Licht an' : 'Licht aus';
    });
  }

  function gewaehlt() {
    try { return localStorage.getItem(SCHLUESSEL) === 'an'; } catch (e) { return false; }
  }
  function merken(an) {
    try { localStorage.setItem(SCHLUESSEL, an ? 'an' : 'aus'); } catch (e) { /* privat */ }
  }

  function start() {
    dimmerLesen();
    knoepfeSetzen();
    anwenden(gewaehlt());        // ohne Blende - siehe "Der Dimmer"

    // NACH DEM LADEN NOCH EINMAL, hart. Beim DOMContentLoaded steht das
    // Layout der Bilder noch nicht fest: ein Bild ohne geladene Datei
    // hat oft die Hoehe 0, und ohne Kasten kann paarBauen() nicht
    // pruefen, ob ein Gegenstueck deckungsgleich darueber passt - es
    // sagt vorlaeufig ab. Am Pruefstand traf das die Kollektionskachel
    // (Rasterzelle, Hoehe erst nach dem Laden). Der Beobachter unten
    // haette sie irgendwann nachgeholt, aber nur, wenn sich sonst noch
    // etwas ruehrt; auf einer ruhigen Seite blieb sie fuer immer ohne
    // Paar und schaltete als einzige hart um. Also einen festen Anlass
    // schaffen. Ohne Blende - der Seitenaufbau blendet nie.
    if (document.readyState !== 'complete') {
      window.addEventListener('load', function () {
        knoepfeSetzen();
        anwenden(gewaehlt());
      }, { once: true });
    }

    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-lichtschalter]');
      if (!b) return;
      // Die Kachel ist ein Link - ohne das hier landet man im Produkt.
      e.preventDefault();
      e.stopPropagation();
      var an = !gewaehlt();
      merken(an);
      anwenden(an, true);        // der einzige Ort, an dem geblendet wird
    }, true);

    // Das Theme laedt nach und setzt src erst beim Sichtbarwerden. Neben
    // neuen Knoten werden deshalb auch Attributaenderungen beobachtet -
    // nur childList reichte nicht, faul geladene Bilder blieben sonst im
    // falschen Zustand stehen.
    var warte = null, laeuft = false;
    new MutationObserver(function () {
      if (laeuft) return;
      clearTimeout(warte);
      warte = setTimeout(function () {
        laeuft = true;                 // eigene Aenderungen nicht nachjagen
        knoepfeSetzen();
        anwenden(gewaehlt());
        setTimeout(function () { laeuft = false; }, 60);
      }, 160);
    }).observe(document.documentElement, {
      childList: true, subtree: true,
      attributes: true,
      attributeFilter: ['src', 'srcset', 'data-src', 'data-srcset', 'class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
